import {get,post,put} from './base'

/**
 * 直播会议列表
 * @returns {Promise<unknown>}
 */
export function getLive_meet(page_no,title){
    return get("/api/admin/liveMeet",{page_no,"page_size":10,title})
}